var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", [
    _c(
      "a",
      {
        staticClass: "element",
        attrs: {
          href: _vm.model.Url,
          target: _vm.model.External ? "_blank" : "",
        },
      },
      [
        _c("div", { staticClass: "element__preview" }, [
          _c("img", {
            attrs: { "data-srcset": _vm.model.Image, alt: _vm.model.ImageAlt },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "element__details element__details_wide" }, [
          _c("div", { staticClass: "element__line" }, [
            _c("div", {
              staticClass: "stage",
              domProps: { innerHTML: _vm._s(_vm.model.Tag) },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "element__rating" },
              _vm._l(_vm.model.StarRating, function (i) {
                return _vm.model.StarRating > 0
                  ? _c("div", { staticClass: "element__star" }, [
                      _c("img", {
                        attrs: { src: "/public/img/star.svg", alt: "" },
                      }),
                    ])
                  : _vm._e()
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "element__title" }, [
            _vm._v(_vm._s(_vm.model.Name)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "element__content" }, [
          _vm._v(_vm._s(_vm.model.ShortDescription)),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }